export const it = {
    $vuetify: {
        dataIterator: {
            noResultsText: "Nessun risultato trovato",
        },
        noDataText: "Nessun elemento disponibile",
        dataTable: {
            itemsPerPageText: "Righe per pagina:",
            pageText: "{0}-{1} di {2}",
            sortBy: "Ordina per",
        },
        dataFooter: {
            firstPage: "Prima pagina",
            itemsPerPageAll: "Tutti",
            itemsPerPageText: "Righe per pagina:",
            lastPage: "Ultima pagina",
            nextPage: "Pagina seguente",
            pageText: "{0}-{1} di {2}",
            prevPage: "Pagina precedente",
        },
    },
    payoffs: {
        0: "Ottimizza la gestione dei corrieri",
        1: "Monitora lo stato di avanzamento delle consegne",
        2: "Aggiorna in tempo reale i tuoi clienti",
        3: "Tieni sotto controllo pagamenti e incassi",
        4: "Accedi da qualsiasi dispositivo",
    },
    roles: {
        0: "Non autenticato",
        1: "Admin",
        2: "Esercente",
        3: "Acquirente",
        4: "Fattorino"
    },
    rolesIcon: {
        0: "mdi-login",
        1: "mdi-account",
        2: "mdi-storefront",
        3: "mdi-face",
        4: "mdi-bike-fast",
    },
    currencyCode: {
        default: "€",
        EUR: "€",
        USD: "$",
        GBP: "£",
        RUB: "₽",
    },
    orderType: {
        1: "Fattura",
        2: "DDT",
        3: "Ricevuta Fiscale",
        4: "Corrispettivo",
        5: "Ordine",
        6: "Fattura corrispettivi",
        7: "Scarico merci",
        8: "Proforma",
    },
    deliveryState: {
        10: "Da assegnare",
        20: "Assegnata",
        30: "In corso",
        40: "Destinatario errato",
        50: "Sospesa",
        60: "Annullata",
        61: "Cancellata da gestionale",
        70: "",
        80: "",
        90: "Non consegnata",
        100: "Consegnata",
    },
    walletMovementsType: {
        0: "Fondo Cassa",
        1: "Incasso Consegna",
        2: "Prelievo Incassi",
    },
    dateFormat: {
        date: "DD-MM-YYYY",
        dateTime: "DD-MM-YYYY HH:mm",
        time: "HH:mm",
    },
    common: {
        actions: "Azioni",
        cancel: "Annulla",
        confirm: "Conferma",
        changeProfile: "Cambia profilo",
        city: "Città",
        clear: "Pulisci",
        close: "Chiudi",
        continue: "Continua",
        create: "Crea",
        delete: "Elimina",
        edit: "Modifica",
        export: "Esporta",
        guide: "Manuale Online",
        load: "Carica",
        loading: "Caricamento dati...",
        logout: "Esci",
        no: "No",
        operationSuccessfully: "Operazione conclusa con successo",
        operationError: "Errore nell'esecuzione dell'operazione",
        refresh: "Aggiorna",
        restore: "Ripristina",
        reset: "Reset",
        save: "Salva",
        search: "Cerca",
        show: "Visualizza",
        route: "Indicazioni",
        state: "Provincia",
        yes: "Si",
        zipcode: "Cap",
        from: "Dalle:",
        of: "del:",
        to: "alle:",
    },
    forms: {
        email_required: "L'e-mail è obbligatoria",
        field_min_length: "Il campo deve avere più di {count} caratteri",
        field_required: "Campo obbligatorio",
        password_validation: "La password deve avere più di {count} caratteri",
        email_validation: "L'e-mail deve essere di un formato valido",
        password_confirm: "Le password devono essere uguali",
        password_format: "La password deve contenere almeno 1 carattere maiuscolo, 1 minuscolo, 1 numero e 1 carattere speciale",
        password_required: "La password è obbligatoria",
    },
    pages: {
        admin: {
            common: {},
            report: {
                disabled: "Disabilitato",
                idStore: "Id",
                identifier: "Identificativo",
                storeDescription: "Portale",
                title: "Report",
                totClosedOrders: "Ordini chiusi",
                totNewCustomers: "Nuovi clienti",
                totRidersWithClosedOrders: "Fattorini",
            },
            communications: {
                title: "Comunicazioni",
                subject: "Oggetto",
                text: "Testo",
                type: "Tipologia",
                startDate: "Data Inizio",
                startTime: "Ora Inizio",
                endDate: "Data Fine",
                endTime: "Ora Fine",
                periodValidity: "Periodo di validità",
                description: "Descrizione",
                edit: "Modifica",
                delete: "Elimina",
                actions: "Azioni",
                color: "Colore",
                deleteDialog: {
                    title: "Eliminazione Comunicazione",
                    text: "Sei sicuro di voler eliminare la comunicazione?",
                },
                types: {
                    success: "Successo",
                    info: "Info",
                    warning: "Warning",
                    error: "Errore",
                },
                dismissible: "Chiudibile",
                destination: "Destinazione"
            },
            stores: {
                description: "Descrizione",
                disabled: "Disabilitato",
                emailManager: "Email Manager",
                emailSupport: "Email Support",
                id: "Id",
                identifier: "Identificativo",
                phoneNumber: "Telefono",
                title: "Portali",
                vatNumber: "P.Iva",
            },
            users: {
                email: "Email",
                idStore: "Id Portale",
                impersonates: "Impersonifica",
                name: "Nome",
                numRoles: "Numero Ruoli",
                phoneNumber: "Telefono",
                primaryRole: "Ruolo primario",
                roles: "Ruoli",
                storeRole: "Ruolo",
                surname: "Cognome",
                title: "Utenti",
            },
        },
        signin_signup: {
            login: "Accedi",
            signin: "Entra",
            signup: "Registrati",
            resetPassword: {
                forgotPassword: "Password dimenticata?",
                email: "Indirizzo e-mail",
                dialogTitle: "Recupero password",
                dialogText: `Inserisci l'e-mail dell'account che vuoi recuperare.`,
                dialogSend: "Invia",
                dialogAbort: "Annulla",
                dialogSuccess: "Grazie! È stata inviata una mail all'indirizzo indicato.",
            },
        },
        choose_profile: {
            title: "Scegli profilo",
            whichProfile: "Con quale profilo vuoi accedere?",
            noProfile: "Siamo spiacenti ma non hai nessun profilo associato al tuo account.",
        },
        orders: {
            closedOrder: "Consegne chiuse",
            openOrders: "Consegne aperte",
            datesFilter: "Filtro date",
            title: "Storico consegne",
        },
        order_detail: {
            customer: "Acquirente",
            order: "Consegna",
            orderState: "Stato consegna",
            products: "Dettaglio prodotti",
            packages: "Dettaglio colli",
            receipt: "Scontrino",
            rider: "Fattorino",
            shipping: "Indirizzo spedizione",
            signature: "Firma",
            title: "Dettaglio consegna",
            deliveryNotes: "Note aggiuntive consegna",
            saveDeliveryNotes: "Salva nota",
        },
        dashboard: {
            title: "Pannello di controllo",
            state: { online: "Online", offline: "Offline" },
            deliveryList: "Lista consegne",
            deliveryMap: "Mappa consegne",
            changeRiderState: "Cambia il tuo stato",
            codeScanner: "Scansiona codice",
            cameraPermissionError: "Devi attivare i permessi alla Fotocamera",
            orderAssignmentSucces: "Consegna presa in carico",
            orderAssignmentError: "Errore nell'assegnazione della spedizione",
            OrderNotFound: "Spedizione non trovata",
            InvalidIdentifier: "Codice non valido",
            OrderAlreadyAssigned: "Spedizione già assegnata",
            riderStateError: "Impossibile cambiare lo stato: L'utente è già attivo su un altro store.",
        },
        riders: {
            title: "Fattorini",
            deleteRiderDialog: {
                title: "Eliminazione Fattorino",
                text: "Sei sicuro di voler eliminare il fattorino?",
            },
            tabs: {
                riders: {
                    title: "Lista Fattorini"
                },
                planning: {
                    title: "Planning Disponibilità",
                    today: "Oggi",
                    calendarViewLabel: "Tipo Vista",
                    calendarViewValue: {
                        week: "Settimanale",
                        day: "Giornaliero",
                        category: "Diviso per Rider"
                    },
                    calendarWeekdaysLabel: "Giorni visualizzati",
                    calendarWeekdaysValue: {
                        1: "da Lunedi a Venerdi",
                        2: "da Lunedi a Sabato",
                        3: "da Lunedi a Domenica",
                        4: "Venerdì, Sabato, Domenica",
                        5: "Sabato, Domenica",
                        6: "Una settimana a partire da oggi"
                    },
                    calendarEventOverlapLabel: "Modalità di sovrapposizione degli eventi",
                    calendarEventOverlapValue: {
                        stack: "Sovrapposti",
                        column: "Incolonnati"
                    },
                    calendarNumberOfDaysLabel: "Giorni da mostrare"
                }
            }
        },
        ridersAvailability: {
            title: "Disponibilità Fattorino",
            today: "Oggi",
            hours: "Ore",
            minutes: "Minuti",
            availability: "Disponibilità",
            programmedHours: "Ore programmate",
            of: "Del",
            savingAvailability: {
                success: "Disponibilità salvata con successo",
                error: "Errore nel salvataggio. Controlla gli orari inseriti.",
            },
            deletingDialog: {
                title: "Eliminazione disponibilità",
                message: "Vuoi eliminare la disponibilità <br><strong>{availability}</strong> del <strong>{day}</strong> ?",
            },
        },
        vehicles: {
            title: "Veicoli",
        },
        vehicle_edit: {
            title: "Dettaglio veicolo",
            description: "Descrizione veicolo",
            licensePlate: "Targa",
            number: "Numero",
            typeCode: "Tipo",
            capacity: "Capacità",
            maxPayload: "Carico massimo",
            shelving: "Copertura",
            hooks: "Gancio traino",
            ceilingLight: "Illuminazione interna",
            airIntakeForVentilation: "Ventilazione",
            isRefrigerated: "Veicolo refrigerato",
            isothermalCode: "Codice isotermico",
            fridgeCode: "Codice frigo",
            refrigeratedCode: "Codice refrigeratore",
            heatingCode: "Codice riscaldatore",
            insulated: "Isolamento",
            thermalApproved: "Approvazione termica",
            atpExpirationDate: "Scadenza ATP",
            atpCategoryCode: "Categoria ATP",
            noNegativeValue: "Questo valore non può essere negativo!",
            valueLenghtLimit: "Inserire massimo {count} caratteri.",
            createdVehicle: "Veicolo creato con successo!",
            editedVehicle: "Veicolo modificato con successo!",
            deletingDialog: {
                title: "Eliminazione veicolo",
                message: "Eliminare il veicolo '{vehicle}' ?",
            },
        },
        my_account: {
            changePassword: "Cambia password",
            confirmPassword: "Conferma password",
            currentPassword: "Password attuale",
            email: "E-mail",
            name: "Nome",
            newPassword: "Nuova password",
            phoneNumber: "Numero di telefono",
            surname: "Cognome",
            title: "Gestisci account",
            userData: "Dati utente",
        },
        stores: {
            title: "Gestione Portale",

            store_upload_logo: {
                title: "Modifica logo",
                logo: "Logo",
                uploadLogo: "Carica logo",
                uploadLogoValidity: `<ul>
            <li>Inserire un'immagine tra quelle accettate (.png/.jpg)</li>
            <li>Il peso del file deve essere massimo di {size} kB</li>
            <li>La risoluzione massima dell'immagine è di {width}x{height}px</li></ul>`,
                uploadLogoSizeError: "La dimensione dell'immagine deve essere massimo {size} kB!",
                uploadLogoTypeError: "L'immagine deve avere come estensione '.png /.jpg ' !",
                uploadLogoGenericError: "Errore nel caricamento del logo;",
                uploadLogoSuccess: "Logo caricato correttamente!",
            },
            store_informations: {
                title: "Informazioni generali",
                storeDescription: "Descrizione",
                storePhone: "Numero telefonico",
                storeSupportMail: "Email supporto",
                storeVatNumber: "Partita IVA",
                uploadInformationsSuccess: "Informazioni esercente correttamente aggiornate!",
                uploadInformationsError: "Errore nell'aggiornamento delle informazioni dell'esercente.",
            },
            store_map_conf: {
                title: "Configurazione Mappe",
                googleMaps: "Utilizza le mappe di Google",
                googleApiKey: "Google API Key",
                googleApiUrlTip: "Copia questo URL e incollalo nella sezione 'Restrizioni relative ai siti web' della tua Google API Key: ",
                customServerMaps: "Utilizza un tuo server mappe",
                customServerUrl: "Url Server: ",
                customServerUrlTip: "L'url del server deve essere di questo tipo: ",
            },
            store_configuration: {
                order: {
                    rider: {
                        title: "Configurazione ordini fattorino",
                        showItemsPrice: "Mostra importi dettaglio documento se incasso uguale a 0€",
                        showTotalPrice: "Mostra totale documento se incasso uguale a 0€",
                        showOrderItems: "Mostra dettaglio documento se incasso uguale a 0€",
                    }
                }
            },
            store_remove_logo: {
                title: "Rimuovi logo",
                removeLogoSuccess: "Logo rimosso con successo.",
                removeLogoError: "Errore nella rimozione del logo.",
            },
        },
        store_statistic: {
            title: "Statistiche",
            orderByDates: "TOTALE SPEDIZIONI",
            customerByCity: "Clienti suddivisi per città",
            totalsByCity: "Totale valore spedizione suddivise per città",
            customerByZipCode: "Clienti suddivisi per CAP",
            totalsByZipCode: "Totale valore spedizione suddivise per CAP",
            customerByState: "Clienti suddivisi per provincia",
            totalsByState: "Totale valore spedizione suddivise per provincia",
            totalDelivery: "SPEDIZIONI",
            totalCustomer: "CLIENTI",
            totalRider: "FATTORINI",
            totalValue: "VALORE (€)",
            total: "TOTALE",
            general: "STATISTICHE SPEDIZIONI",
            trend: "TREND SPEDIZIONI",
            rider: "STATISTICHE SPEDIZIONI",
            payment: "STATISTICHE PAGAMENTI",
        },
        wallet: {
            title: "Gestione portafoglio",
            movementsList: "Lista movimenti",
            dialogConfirmTitle: "Modifica Fondi",
            dialogConfirmText: "Sei sicuro di voler modificare i fondi?",
        },
        resetPassword: {
            title: "Cambio password",
            newPassword: "Nuova password",
            confirmPassword: "Conferma password",
            email: "E-mail",
            change: "Conferma",
            reset: "Reset",
            backToLogin: "Login",
            resetPasswordSuccess: "La password è stata modificata con successo!",
        },
    },
    registry: {
        address: "Indirizzo",
        city: "Città",
        companyName: "Società",
        description: "Descrizione",
        email: "Email",
        fiscalCode: "Codice Fiscale",
        latitude: "Latitudine",
        longitude: "Longitudine",
        mobilePhone: "Telefono mobile",
        name: "Nome",
        notes: "Note",
        phone: "Telefono",
        state: "Provincia",
        surname: "Cognome",
        type: "Tipo",
        zipCode: "Cap",
        customerDeliveryNotes: "Note consegna acquirente",
    },
    orders: {
        amountPaid: "Totale Pagato",
        currencyCode: "Valuta",
        customer: "Acquirente",
        date: "Data",
        rifDate: "Data documento",
        deliveryDate: "Consegna prevista il",
        deliveredDate: "Consegnato il",
        deliveredDateLong: "Data di consegna effettuata",
        deliveryTime: "Ora di consegna",
        description: "Descrizione",
        discount: "Sconto",
        finalPrice: "Prezzo finale",
        id: "Id",
        identifier: "Identificativo",
        items: "Prodotti",
        morePositions: " | e 1 altro prodotto... | e altri {count} prodotti...",
        notes: "Note",
        packageNumber: "Num. colli",
        paymentDescription: "Tipo pagamento",
        rider: "Fattorino",
        shippingDetail: "Dettagli di consegna",
        state: "Stato",
        totalPrice: "Prezzo totale",
        totalPriceToPay: "Totale da pagare",
        totalPriceToCashOut: "Totale da incassare",
        type: "Tipo",
        riderDeliveryPhoneNumber: "Nr. telefonico Fattorino",
        deliveryDateChanger: {
            estimatedDeliveryDate: "Data di consegna stimata",
            estimatedDeliveryTime: "Ora di consegna stimata",
        },
    },
    positions: {
        code: "Codice",
        depth: "Profondità",
        description: "Descrizione",
        dimension: "Dim. (A x L X P)",
        discount: "Sconto",
        finalPrice: "Totale",
        grossWeight: "Peso lordo",
        height: "Altezza",
        identifier: "Identificativo",
        length: "Larghezza",
        lotCode: "Codice lotto",
        lotIdentifier: "Lotto identificativo",
        netWeight: "Peso netto",
        price: "Prezzo",
        quantity: "Qtà",
        type: "Tipo",
        unitCode: "Codice",
        vat: "IVA",
    },
    vehicles: {
        activate: "Attiva",
        active: "Attivo",
        airIntakeForVentilation: "Presa d'aria per areazione",
        anotherVehicleAssigned: "Hai già un altro veicolo associato",
        assignedTo: "Assegnato a",
        atpCategoryCode: "Categoria ATP",
        atpExpirationDate: "Scadenza certificazione ATP",
        capacity: "Capacità",
        ceilingLight: "Plafoniera",
        changeState: "Cambia stato",
        deactivate: "Disattiva",
        description: "Descrizione",
        fridgeCode: "Frigorifero",
        heatingCode: "Calorifero",
        hooks: "Ganci",
        insulated: "Coibentato",
        isRefrigerated: "Mezzo refrigerato",
        isothermalCode: "Isotermico",
        licensePlate: "Targa",
        matchVehicle: "Associa veicolo",
        maxPayload: "Carico Max.",
        number: "Matricola",
        owner: "Proprietario",
        refrigeratedCode: "Refrigerato",
        shelving: "Scafalatura",
        thermalApproved: "Omologato Termico",
        typeCode: "Tipo veicolo",
        useRiderVehicle: "Assegna veicolo del fattorino",
    },
    riders: {
        actions: "Azioni",
        active: "Attivo",
        assign: "Assegna",
        delivery: "Consegna",
        assignRider: "Assegna fattorino",
        assignVehicle: "Assegna veicolo",
        deleteRider: "Elimina fattorino",
        email: "Email",
        from: "Dalle:",
        manageRiders: "Gestisci fattorino",
        manageVehicle: "Gestisci veicolo",
        manageWallet: "Gestisci portafoglio",
        editRider: "Modifica fattorino",
        name: "Nominativo",
        nextAvailability: "Prossima disponibilità",
        of: "del:",
        owner: "Proprietario",
        phone: "Telefono",
        remove: "Rimuovi",
        removeRider: "Rimuovi fattorino",
        removeVehicle: "Rimuovi veicolo",
        riderNotExists: "Il fattorino non fa più parte della tua organizzazione",
        state: "Stato",
        showCustomerInfo: "Nascondi dettaglio cliente dal giorno successivo alla consegna",
        showFiscalInfo: "Mostra informazioni fiscali",
        to: "alle:",
        vehicle: "Veicolo",
        walletBalance: "Saldo",
    },
    wallet: {
        amount: "Importo",
        balance: "Saldo",
        date: "Data",
        order: "Consegna",
        type: "Tipo",
        addFunds: "Deposita fondi",
        removeFunds: "Preleva fondi",
        add: "Deposita",
        remove: "Preleva",
    },
    map: {
        all: "Vedi tutti",
        center: "Centra Mappa",
        deliveryStateDescr: {
            0: "Visualizza tutte le consegne",
            10: "Visualizza le consegne da assegnare",
            20: "Visualizza le consegne Assegnate",
            30: "Visualizza le consegne in corso",
            40: "Consegne con destinatario errato",
            50: "Visualizza le consegne sospese",
            60: "Visualizza le consegne annullate",
            61: "Visualizza le consegne cancellate",
            70: "",
            80: "",
            90: "Visualizza non consegnate",
            100: "Visualizza consegnate",
        },
    },
    errors: {
        VehicledJustAssigned: {
            text: "Se clicchi su continua questo diventerà il tuo veicolo associato.",
            title: "Hai già un altro veicolo assegnato",
        },
        sessionExpired: "Sessione scaduta",
        genericError: "Sì è verificato un errore",
        serverError: "Sì è verificato un errore imprevisto. Si prega di ricaricare la pagina e riprovare.",
        storeDisabled: "Il tuo portale è disabilitato. Contattare il servizio di assistenza.",
    },
};